import { render, staticRenderFns } from "./ProficiencyBadgeUpgraded.vue?vue&type=template&id=782b8730"
import script from "./ProficiencyBadgeUpgraded.vue?vue&type=script&lang=js"
export * from "./ProficiencyBadgeUpgraded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports